module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad2/img_cta01-167f4d2266a044b0b2d2686d50869aa2.png";